import React from "react";
import { Currency } from "../../../utils/constants.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const CurrencyDropdown = ({
  resources,
  currency,
  onCurrencyChange,
  containerClass,
  filter,
  id = "currency-dropdown",
  disabled = false,
  addMarginBottom = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Currency"]}
      value={currency}
      values={Currency}
      handleChange={onCurrencyChange}
      inputName="currency"
      addMarginBottom={addMarginBottom}
      disabled={disabled}
      containerClass={containerClass}
      map={c => ({ key: c.key, name: c.name })}
      filter={filter}
    />
  );
};

export default CurrencyDropdown;